import { render, staticRenderFns } from "./installConfig.vue?vue&type=template&id=359a9edc&scoped=true"
import script from "./installConfig.vue?vue&type=script&lang=js"
export * from "./installConfig.vue?vue&type=script&lang=js"
import style0 from "./installConfig.vue?vue&type=style&index=0&id=359a9edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359a9edc",
  null
  
)

export default component.exports